import { Button, Checkbox, ContextMenu, Divider, NotificationBadge } from '@volvo/vcdk-react';
import React, { useState } from 'react';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';

type SelectMenuProps = {
  label: string;
  options: { text: string; value: string; disabled?: boolean }[];
  selectedItems: string[];
  onChange: (selectedValues: string[]) => void;
  hideCountForValues?: string[]; // Values to exclude from badge count
};

const SelectMenu: React.FC<SelectMenuProps> = ({
  label,
  options,
  selectedItems,
  onChange,
  hideCountForValues = [],
}) => {
  const [reference, setReference] = useState<HTMLElement | null>(null);

  const hasOptions = options && options.length > 0;

  // Calculate visible count (excluding hidden values)
  const visibleCount = selectedItems.filter((item) => !hideCountForValues.includes(item)).length;

  return (
    <>
      <Button
        variant="secondary"
        iconEnd="chevron-down"
        size="medium"
        ref={(ref) => setReference(ref)}
        disabled={!hasOptions}
      >
        <span className="flex items-center justify-center gap-3">
          {label}
          {visibleCount > 0 && <NotificationBadge content={visibleCount.toString()} />}
        </span>
      </Button>
      {hasOptions && (
        <ContextMenu reference={reference} trigger="click" placement="bottom-start">
          <div className="max-h-[300px] overflow-auto">
            {options?.map((option) => (
              <div key={option.value} className="px-5 py-4">
                <Checkbox
                  disabled={option.disabled}
                  label={option.text}
                  checked={selectedItems.includes(option.value)}
                  onChange={() => {
                    if (selectedItems.includes(option.value)) {
                      onChange(selectedItems.filter((item) => item !== option.value));
                    } else {
                      onChange([...selectedItems, option.value]);
                    }
                  }}
                />
              </div>
            ))}
          </div>
          <Divider />
          <div className="px-5 pb-4">
            <Button variant="secondary" className="w-full" onClick={() => onChange([])}>
              Clear
            </Button>
          </div>
        </ContextMenu>
      )}
    </>
  );
};

export default withComponentErrorBoundary(SelectMenu);
